import { memo } from "react";
import { Link } from "react-router";
import { useClientContext } from "components/ClientContext";
import { config } from "config";
import { links } from "links";

import LogoImage from "./images/CTG-Affiliate_logo_white.svg";

import styles from "./style.module.scss";

export const Logo = memo<{ link?: string }>(({ link }) => {
  const client = useClientContext();

  return (
    <div className={styles.logoContainer}>
      <Link to={link || links.appRoot} className={styles.logoLink}>
        {(() => {
          switch (client) {
            case "mediDrive":
              return null;
            default:
              return <img src={LogoImage} className={styles.logo} alt="CTG Affiliate" />;
          }
        })()}
      </Link>
      {
        [ "development", "staging" ].includes(config.environment || "") &&
        <span className={styles.logoEnv}>{config.environment}</span>
      }
    </div>
  );
});

export default Logo;